import { render, staticRenderFns } from "./BoothFAQ.vue?vue&type=template&id=c9df3abc&scoped=true&"
import script from "./BoothFAQ.vue?vue&type=script&lang=ts&"
export * from "./BoothFAQ.vue?vue&type=script&lang=ts&"
import style0 from "./BoothFAQ.vue?vue&type=style&index=0&id=c9df3abc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9df3abc",
  null
  
)

export default component.exports